module.exports = __webpack_public_path__ + "img/fankui-success-icon.d84b5ad7.png";